const StrateHappyAtWork = {
    init() {
        const breakpointResponsive = 1260;
        const strates = document.querySelectorAll('.strate-happy-at-work');
        
        // si la strate existe
        if (strates) {
            // console.log('strate-happy-at-work');

            strates.forEach(strate => {
                // const slider = strate.querySelector('.slider_mobile');
                const sliders = $('.slider_mobile_happy_at_work');

                if ($(window).width() < breakpointResponsive) {
                    sliders.addClass('owl-carousel');

                    sliders.owlCarousel({
                        loop: true,
                        margin: 20,
                        items: 1,
                        nav: false,
                        dots: true,
                        stagePadding: 0,
                        autoWidth: true,
                    });
                }

                
                
            });
            // const sliderItem = $('.header-carriere .wrapper_temoignage');
            // const sliderWrapper = $('.header-carriere .wrapper_slider');

            // if ($(window).width() < breakpointResponsive) {
            //     if (sliderItem.length > 1) {
            //         headerCarriere.build(sliderWrapper);
            //     }
            // }

            // $(window).resize(function() {
            //     if ($(window).width() < breakpointResponsive) {
            //         headerCarriere.build(sliderWrapper);
            //     } else {
            //         headerCarriere.destroy(sliderWrapper);
            //     }
            // });
        }
    },

    build(sliderWrapper) {
        // sliderWrapper = sliderWrapper.addClass('owl-carousel');

        // sliderWrapper.owlCarousel({
        //     loop: true,
        //     margin: 20,
        //     items: 1,
        //     center: true,
        //     nav: false,
        //     dots: true,
        //     stagePadding: 0,
        //     autoWidth: false,
        // });
    },

    destroy(sliderWrapper) {
        // sliderWrapper.trigger('destroy.owl.carousel');
        // sliderWrapper.removeClass('owl-carousel');
    },
};

export default StrateHappyAtWork;
